<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
        <Modal v-model:visible="show_detail" backdrop>
            <template v-slot:header>
                <h2 class="text-2xl font-bold">Dettaglio</h2>
            </template>
            <template v-slot:main>
                <table>
                    <tr v-for="(v,k) in detail" :key="k">
                        <td class="w-1/2 font-bold border border-next-dark-gray">{{ k }}:</td>
                        <td class="w-1/2 border border-next-dark-gray">{{ v }}</td>
                    </tr>
                </table>
            </template>
            <template v-slot:footer>
                <div class="flex justify-between pt-3">
                    <NextButton variant="outline-secondary"
                                @click="show_detail =false"
                                class="py-2 px-4 w-full">
                        Chiudi
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
    <div class="m-auto px-8 pb-8">
        <div class="m-auto pt-5">
            <div class="flex items-center justify-between">
                <h2 class="text-3xl font-bold mb-4">Costi biglietteria ferroviaria: {{
                        lista.rows[0]?.nodo || '---'
                    }}</h2>
                <NextButton :disabled="loading_download" variant="secondary" class="p-2" @click="export_data">Esporta
                </NextButton>
            </div>
            <div class="flex flex-col col-span-2 mb-2">
                <Field field_name="Cerca" @update:modelValue="lista.debounceSearch"
                       v-model="lista.search"
                       placeholder="Cerca"></Field>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 border-separate border-spacing-3 py-4 table-fixed"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">

                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                        {{ $filters.toDate(c.Travel_date) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                        {{ $filters.toEuroCurrency(c.PaymentAmount || 0) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_9`]="context">
                        <span @click="showData(c)"
                              class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></span>

                    </template>

                </NextTable>
            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre righe.</div>
                </template>
            </InfiniteLoading>

        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import sottoProgettiManager from "@/api/SottoProgetti";
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import Paginator from "@/components/Paginator.vue";
import NextTable from "@/components/NextTable.vue";
import Lista from "@/setup/ListaCerca";
import InfiniteLoading from "v3-infinite-loading";


@Options({
    name: 'CostiRicaviBiglietteriaFerroviariaSottoProgetto',
    components: {NextTable, Paginator, Field, InfiniteLoading, Loading, Modal, NextButton},
    props: {
        id: [Number, String],
    },
    computed: {},
    methods: {}
})
export default class CostiRicaviBiglietteriaFerroviariaSottoProgetto extends Vue {
    lista: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.costiBiglietteriaFerroviaria));
    id!: string;
    show_detail = false
    detail = null
    loading_download = false

    created() {
        this.lista.callBinds = [this.id]
        this.lista.sort = 'PSGRCOGNOME'
        this.lista.fetchData()
    }

    showData(data: any) {
        this.detail = data
        this.show_detail = true
    }

    export_data() {
        this.loading_download = true
        sottoProgettiManager.costiBiglietteriaFerroviaria(this.id, {
            responseType: 'blob', params: {export:1,
                sort: this.lista.sort, ...this.lista.searchParam(), ...this.lista.apiParams.value
            },
        }).then((response: any) => {
            let downloadUrl = URL.createObjectURL(response.data);
            let a = document.createElement("a");
            a.href = downloadUrl;
            a.download = `costi_biglietteria_ferroviaria_${this.lista.rows[0]?.nodo}.xlsx`;
            document.body.appendChild(a);
            a.click();
        }).finally(() => {
            this.loading_download = false
        })
    }

    cols = [

        {
            name: 'Cognome',
            prop: 'PSGRCOGNOME',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Nome',
            prop: 'PSGRNOME',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Tipo record',
            prop: 'Tipo_record',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Data',
            prop: 'Travel_date',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Itinerario',
            prop: 'Itinerary',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Costo',
            prop: 'paymentAmount',
            orderable: true,
            class: 'whitespace-nowrap',
            td_class: 'px-2 text-right bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'N° biglietto',
            prop: 'ticketId',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'PNR',
            prop: 'tickePNR',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'CP',
            prop: 'ticketCP',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss" scoped>
.table-costi-ricavi {
    td {
        @apply p-2 text-sm relative bg-next-gray-md-dark
    }
}
</style>
